var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      ref: "select",
      staticClass: "input_width_180 dg-select",
      style: _vm.DgStyle,
      attrs: {
        "remote-method": _vm.filterMethod,
        filterable:
          _vm.innerOptions.length > _vm.filterLimit || _vm.allowCreate,
        "allow-create": _vm.allowCreate,
        remote: _vm.innerOptions.length > _vm.filterLimit,
        size: _vm.size,
        multiple: _vm.multiple,
        "collapse-tags": _vm.collapseTags,
        clearable: _vm.clearable,
        placeholder: _vm.placeholder || (_vm.disabled ? "" : "请选择"),
        disabled: _vm.disabled,
        "popper-append-to-body": _vm.popperAppendToBody,
      },
      on: { "visible-change": _vm.handleVisibleChange, change: _vm.change },
      model: {
        value: _vm.innerValue,
        callback: function ($$v) {
          _vm.innerValue = $$v
        },
        expression: "innerValue",
      },
    },
    _vm._l(_vm.layoutOptions, function (item) {
      return _c(
        "el-option",
        _vm._b({ key: item.value }, "el-option", item, false)
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }